import React from "react";
import "./style.css";

function StaticBanner({ bannerText, variant }) {
  return <div className={`banner ${variant}`}>{bannerText}</div>;
}

export default StaticBanner;
